import React, {useEffect, useRef, useState} from "react";
import type {MenuProps, TabsProps, TourProps} from "antd";
import { Layout, Menu, Tabs, Tour, Select } from 'antd';
import _ from "lodash";
import "../css/utils.css";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {useSize} from "ahooks";
import {useQuery} from "react-query";
import {getFgaProject, getUser} from "metabase/selectors/user";
import LoadingSpinner from "metabase/components/LoadingSpinner";
import {setToolMenus} from "metabase/redux/control";
import {QUERY_OPTIONS} from "metabase/ab/utils/utils";
import GaProjectSearch from "metabase/ab/components/GaProjectSearch";
import {getOssUrl} from "metabase/lib/image";
import {isProduction} from "metabase/env";
import Icon from "metabase/components/Icon";
import {getToolMenu} from "metabase/new-service";
import {getGrowthProjectPath, getLatestGAProject, saveLatestGAMenuTag,} from "../utils/utils";
import {fga_menu_data_v2} from "../utils/data";
const { Sider } = Layout;

interface IGaSidebarProp {
  className?: string;
  currentProject?: string;
  router: any;
  user: any;
  currentMenu?: string;
  location: any;
  items: any[];
  projects?: any[];
  projectObject?: any;
  setToolMenus?: any;
  collapsed?: boolean;
  setCollapsed?: (collapsed: boolean) => void;
}
const GaSidebar = (props: IGaSidebarProp) => {
  const { currentProject, router, location, currentMenu, projectObject, user, setToolMenus, collapsed, setCollapsed } =
    props;
  const [items, setItems] = useState<any[]>([]);
  const [itemsPlatform, setItemsPlatform] = useState<any[]>([]);
  // const [rootSubmenuKeys, setRootSubmenuKeys] = useState<any[]>([]);
  const [openKeys, setOpenKeys] = useState<string[]>([currentMenu!]);
  const [oldOpenKeys, setOldOpenKeys] = useState<string[]>([currentMenu!]);
  const [ activeTab, setActiveTab ] = useState("dashboards");
  const size = useSize(document.querySelector('body'));
  const refGuide1 = useRef(null);
  const refGuide2 = useRef(null);

  const [tourOpen, setTourOpen] = useState<boolean>(false);

  // useEffect(() => {
  //   const can = (size?.width || 0) < 1920
  //   setCanCollapsed(can)
  //   if (can) setCollapsed(true)
  // }, [size]);


  useEffect(() => {
    if (!projectObject) {return;}
    const itemsTemp: any[] = fga_menu_data_v2(projectObject, user)?.menuTabs || [];
    setItems(itemsTemp);

    const itemsPlatformTemp: any[] = fga_menu_data_v2(projectObject, user)?.platformMenuTabs || [];
    setItemsPlatform(itemsPlatformTemp);

    const toolsMenuKeys = toolMenus?.map((i: any) => i.key)
    console.log("toolsMenuKeys", toolMenus, toolsMenuKeys.includes(currentMenu))
    if (toolsMenuKeys.includes(currentMenu)) {
      setActiveTab("tools")
    }

    // handle the onboard guide
    const onboardGuideStorage = localStorage.getItem("GAOnboardGuide")
    if (onboardGuideStorage !== 'true') {
      setTimeout(() => {
        setCollapsed?.(false)
      }, 1000)
      setTimeout(() => {
        setTourOpen(true)
        localStorage.setItem("GAOnboardGuide", "true")
      }, 2000)
    }
  }, [projectObject]);

  useEffect(() => {
    if (currentMenu) {
      [...items, ...itemsPlatform]?.map(i => {
        if (i.key === currentMenu) {
          if (!collapsed) {
            setOpenKeys([ i.key ]);
          } else {
            setOldOpenKeys([ i.key ])
          }
          return;
        } else if (i.children?.length > 0) {
          i.children.map((child: { key: string; children: [] }) => {
            if (child.key === currentMenu) {
              if (!collapsed) {
                setOpenKeys([ i.key ]);
              } else {
                setOldOpenKeys([ i.key ])
              }
            } else if (child.children?.length > 0) {
              child.children.map((child2: { key: string }) => {
                if (child2.key === currentMenu) {
                  if (!collapsed) {
                    setOpenKeys([i.key,child.key]);
                  } else {
                    setOldOpenKeys([i.key,child.key])
                  }
                }
              });
            }
          });
        }
      });
    }
  }, [currentMenu, items]);

  const onOpenChange: MenuProps["onOpenChange"] = keys => {
    setOpenKeys(keys);
  };

  useEffect(() => {
    if (!collapsed) {
      setOpenKeys(oldOpenKeys);
    } else {
      setOldOpenKeys(openKeys);
    }
  }, [collapsed]);

  const toolMenuQuery = useQuery(
    ["getToolMenu"],
    getToolMenu,
    {
      ...QUERY_OPTIONS,
      onSuccess: (data) => {
        setToolMenus(data)
      },
    },
  );
  const toolMenus: any = fga_menu_data_v2(null, null, toolMenuQuery?.data)?.menuTabs || [];

  const onChange = (key: string) => {
    setActiveTab(key)
  };

  const tabItems: TabsProps['items'] = [
    {
      key: 'dashboards',
      label:  <div className="ga-side-tabs-item" ref={refGuide1}><Icon name={"ab_dashboard2"} size={20} />{collapsed ? "": "Dashboards"}</div>,
      children: (
        <>
          {projectObject ? (
            <div className={"relative flex flex-column full-height overflow-hidden"}>
              <div style={{marginTop: 8}}/>
              <GaProjectSearch
                className={"mt2 mb3"}
                location={location}
                enableFirstGa={true}
                collapsed={collapsed}
              />
              <div style={{marginTop: 10}}/>
              {projectObject?.menu?.length > 0 && (<Menu
                className={`ab-menu ${collapsed ? "ab-menu-collapsed" : ""}`}
                style={{
                  borderRight: "0px",
                  width: "100%",
                  flex: 1,
                  paddingLeft: collapsed ? 0 : 16,
                  paddingRight: collapsed ? 0 : 16,
                  paddingBottom: 60,
                }}
                inlineCollapsed={collapsed}
                theme="dark"
                mode={collapsed ? "vertical" : "inline"}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                selectedKeys={[currentMenu!]}
                onSelect={item => {
                  saveLatestGAMenuTag(item.key);
                  router.push({
                    pathname: getGrowthProjectPath(
                      currentProject ?? getLatestGAProject() ?? "",
                      item.key,
                    ),
                  });
                }}
                items={items}
              />)}
            </div>
          ) : (
            <LoadingSpinner message="Loading..." />
          )}
        </>
      ),
    },
    {
      key: 'tools',
      label:  <div className="ga-side-tabs-item" ref={refGuide2}><Icon name={"ab_tool"} size={20} />{collapsed ? "": "Tools"}</div>,
      children: (
        <div className={"relative flex flex-column full-height overflow-hidden"}>
          <div className={"mt2"}/>
          {toolMenuQuery.isLoading ?
            (
              <LoadingSpinner message="Loading..." />
            )
              :
            (
            <Menu
            className={`ab-menu ${collapsed ? "ab-menu-collapsed" : ""}`}
            style={{
              borderRight: "0px",
              width: "100%",
              flex: 1,
              paddingLeft: collapsed ? 0 : 16,
              paddingRight: collapsed ? 0 : 16,
              paddingBottom: 140,
            }}
            theme="dark"
            mode={collapsed ? "vertical" : "inline"}
            openKeys={!collapsed ? openKeys : []}
            onOpenChange={onOpenChange}
            selectedKeys={[currentMenu!]}
            onSelect={item => {
              saveLatestGAMenuTag(item.key);
              router.push({
                pathname: getGrowthProjectPath(
                  currentProject ?? getLatestGAProject() ?? "",
                  item.key,
                ),
              });
            }}
            items={toolMenus}
          />)}
        </div>
      ),
    },
  ];
  const steps: TourProps['steps'] = [
    {
      title: <div className="flex items-center" style={{ gap: 4}}><Icon name={"ab_dashboard2"} size={20} />Dashboards Tab</div>,
      description: 'Here, you can view data or manage team settings for each project that you have access to.',
      cover: (
        <img
          alt="tour1.png"
          src="https://static.footprint.network/img_tb_tour_1.png?1=1"
        />
      ),
      target: () => refGuide1.current,
    },
    {
      title: (<div className="flex items-center" style={{ gap: 4}}><Icon name={"ab_tool"} size={20} />Tools Tab</div>),
      description: 'Here, you can access useful tools such as Snapshot Tool, Wallet Tracker, or even build your own dashboard with Custom Analysis.',
      cover: (
        <img
          alt="tour2.png"
          src="https://static.footprint.network/img_tb_tour_2.png?1=1"
        />
      ),
      target: () => refGuide2.current,
    },
  ];
  return (
    <Sider
      // ref={ref}
      className={`ga-side-bar dark ${collapsed ? "ga-side-bar-collapse" : ""}`}
      width={collapsed ? 80 : 272}
      collapsed={collapsed}
      onCollapse={(value) => {
        setCollapsed?.(value)
      }}

      trigger={null}
      // onMouseEnter={debouncedHandleMouseEnter}
      // onMouseLeave={debouncedHandleMouseLeave}
      style={{
        position: "absolute",
        zIndex: 100,
        padding: "0px 4px",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
        height: "100%",
        // position: "fixed",
        borderRight: "1px solid #353945",
        background: "#101318 !important",
        // borderRight: "1px solid #ffffff20",
      }}
    >
      <Tour
        className="ga-tour"
        open={tourOpen}
        onClose={() => setTourOpen(false)}
        steps={steps}
        placement={"right"}
        mask={{
          style: {
            boxShadow: 'inset 0 0 15px #333',
          },
          color: 'rgba(0, 0, 0, .7)',
        }}
      />
      <div className={"ga-side-bar__head-panel"} >
        <div className="flex items-center">
          <img
            className={"mr1"}
            src={getOssUrl(
              "ab/tb-logo.png",
            )}
            width={collapsed ? 40 : 24}
            height={collapsed ? 40 : 24}
          />
          {!collapsed && (
            <div className="flex items-center align-baseline text-nowrap overflow-hidden" style={{gap: 4}}>
              <h2>Telegraph Bay</h2>
              {isProduction ? (<span>Ver 1.0</span>) : (<span style={{color: "red", fontSize: 8, marginLeft: 0}}>STAGING</span>)}
            </div>
          )}
        </div>
        {!collapsed && (
          <div className="ga-side-bar__head-panel-toggle-left" onClick={() => setCollapsed?.(true)}>
            <Icon name="collapse_arrow_left" size={20} color={"white"}/>
          </div>
        )}
      </div>
      {collapsed && (
        <div className="ga-side-bar__head-panel-toggle-right" onClick={() => setCollapsed?.(false)}>
          <Icon name="ab_menu_toggle_right" size={20} color={"white"}/>
        </div>
      )}
      <Tabs
        style={{height: "100%"}}
        defaultActiveKey={activeTab}
        items={tabItems}
        activeKey={activeTab}
        centered
        tabBarGutter={collapsed ? 0 : 20}
        onChange={onChange}
      />
    </Sider>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    user: getUser(state),
    projectObject: getFgaProject(state),
    currentProject: props.params.project,
    currentMenu: props.params.menu,
  };
};

const mapDispatchToProps = { setToolMenus };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GaSidebar));
